<template>
  <dp-container v-if="loading">
    <dp-loading />
  </dp-container>
  <dp-container v-else>
    <section>
      <!-- Pet Header & Marketing Banner -->
      <section>
        <marketing-banner
          class="mb-n1 pb-1"
          :variant="city.noLicensing ? 'nonLicensing' : 'default'"
          :city-name="city.name"
          :city-logo="city.letterLogo && city.letterLogo.original ? city.letterLogo.original : null"
        />
      </section>
      <!-- Collection Breadcrumbs -->
      <b-breadcrumb class="bg-white p-1 pl-lg-0 align-items-center">
        <b-breadcrumb-item :to="{ name: 'TagStore' }">Tag Store</b-breadcrumb-item>
        <b-breadcrumb-item class="d-none d-lg-block" active>{{ productGroup ? productGroup.name : '...' }}</b-breadcrumb-item>
        <b-breadcrumb-item class="breadcrumb-item-dropdown d-inline-flex d-lg-none flex-grow-1 align-items-center" active>
          <DpSelect :value="productGroup.name" :options="filteredGroupsWithoutSearch" class="breadcrumb-dropdown" />
        </b-breadcrumb-item>
      </b-breadcrumb>
      <!-- BODY -->
      <section>
        <b-row class="align-items-start" no-gutters>
          <!-- Collections List -->
          <b-col class="d-none d-lg-block collections-list sticky" lg="3" style="top: 1rem">
            <b-link v-for="group in filteredGroupsWithoutSearch" :key="group.id" class="pt-2" :to="group.to">
              <h3 class="font-weight-bold" :class="{ 'text-primary': group.id === $route.params.id }">{{ group.text }}</h3>
            </b-link>
            <b-link :to="{ name: 'TagStore' }">
              <h3 class="font-weight-bold text-primary cursor-pointer pt-2">View All Collections</h3>
            </b-link>
          </b-col>
          <b-col cols="12" lg="9">
            <!-- Product Collection Styles -->
            <ProductStyles :pet-id="''" :group="productGroup" :always-show-all-tags="true">
              <template #group-header="{ group }">
                <h2 class="font-weight-bold text-dark product-group-name mb-2 pl-1 pl-lg-0">{{ group.name }}</h2>
              </template>
            </ProductStyles>
          </b-col>
        </b-row>
      </section>
    </section>
    <section v-if="!productGroup" id="not-found" class="mt-5 mb-4">
      <b-card overlay :img-src="require('@/assets/images/404.jpg')" img-fluid img-alt="" class="border-0">
        <b-card-title class="d-none d-lg-block display-4 font-weight-bold mt-4">Ooops... collection not found!</b-card-title>
        <b-card-title class="d-block d-lg-none h2 font-weight-bold mt-3">Ooops... collection not found!</b-card-title>
        <b-card-body class="mt-lg-5">
          <b-button variant="primary" class="px-5" :to="{ name: 'TagStore' }">View All Collections</b-button>
        </b-card-body>
      </b-card>
    </section>
  </dp-container>
</template>

<script>
import { mapState } from 'vuex';
import { DpContainer, DpLoading } from '@docupet/component-library';
import ProductStyles from '../components/ProductStyles';
import MarketingBanner from '../components/MarketingBanner';
import DpSelect from '../components/library/Select';

export default {
  name: 'Collection',
  components: {
    DpSelect,
    MarketingBanner,
    ProductStyles,
    DpContainer,
    DpLoading,
  },
  metaTag() {
    return {
      ...this.$router.currentRoute.meta,
      title: `${this.productGroup?.name || ''} -`,
      meta: [
        { charset: 'utf-8' },
        {
          vmid: 'description',
          name: 'description',
          content: this.productGroup?.description || '',
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: this.productGroup?.description || '',
        },
      ],
    };
  },
  computed: {
    ...mapState({
      cityId: (state) => state.cityId,
      city: (state) => state.user.city,
      loading: (state) => state.tagProduct?.loading,
      productGroups: (state) => state.tagProduct?.groups || [],
    }),
    productGroup() {
      return this.productGroups?.find?.((group) => group.id === this.$route.params.id);
    },
    filteredGroupsWithoutSearch() {
      try {
        let groups = [];
        this.productGroups.forEach((group) => {
          if (!group.municipalGroup) {
            groups.push({
              text: group.name,
              value: group.name,
              to: { name: 'TagCollection', params: { id: group.id } },
              sort: group.sort,
              id: group.id,
            });
          }
        });
        groups.sort((a, b) => (a.sort > b.sort ? 1 : -1));
        return groups;
      } catch (e) {
        return [];
      }
    },
  },
  created() {
    this.$store.dispatch('tagProduct/fetchGroups', { cityId: this.city?.id || this.cityId });
  },
  destroyed() {
    this.$store.dispatch('tagProduct/removeGroup');
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
h1 {
  margin-bottom: -2.5rem;
}
#product-group {
  margin-top: -3.8rem;
}
#not-found {
  text-align: center;
  svg {
    color: $dp-gray-2;
    width: 35%;
    height: 35%;
  }
  h2 {
    margin-top: 2rem;
    color: $dp-gray-3;
  }
}
.breadcrumb-item {
  &::before {
    float: none;
    vertical-align: text-top;
  }
  &.breadcrumb-item-dropdown {
    span {
      width: available;
    }
  }
}
</style>

<style lang="scss">
.breadcrumb-dropdown {
  .dropdown-toggle {
    padding: 0.25rem 0.25rem 0.25rem 0.75rem !important;
    svg {
      margin-left: 1rem;
    }
  }
  .dropdown-item {
    padding: 0.5rem 0.25rem 0.5rem 0.75rem !important;
  }
}
</style>
